import { render } from "./OutlineDetails.vue?vue&type=template&id=133d2924&scoped=true"
import script from "./OutlineDetails.vue?vue&type=script&lang=js"
export * from "./OutlineDetails.vue?vue&type=script&lang=js"

import "./OutlineDetails.vue?vue&type=style&index=0&id=133d2924&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133d2924"]])

export default __exports__